import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));
const endDate = new Date("2055/12/31");

const initialState = {
  filterValues: {
    branchArray: [],
    branch: null,
    applicationArray: [],
    applicationNum: null,
    customerId: "",
    expectedDate: currentDate,
    dropDownValue: null,
    expectedEndDate: endDate,
    reason: "",
    instruction: "",
  },

  touchHandler: {
    branchTouched: false,
    applicationNumTouched: false,
    expectedDateTouched: false,
    dropDownValueTouched: false,
    reasonIsTouched: false,
    instructionIsTouched: false,
  },

  valueIsValid: {
    branchIsValid: false,
    applicationNumIsValid: false,
    expectedDateIsValid: true,
    dropDownValueIsValid: false,
    instructionIsValid: false,
    reasonIsValid: false,
  },
};

const SettlementFigureReportReducer = createSlice({
  name: "settlementFigureReport",
  initialState: initialState,
  reducers: {
    updateBranchArray(state, action) {
      state.filterValues.branchArray = action.payload;
    },

    updateBranchValue(state, action) {
      state.filterValues.branch = action.payload;
      state.valueIsValid.branchIsValid =
        action.payload !== "" && action.payload !== null;
    },

    updateApplicationArray(state, action) {
      state.filterValues.applicationArray = action.payload;
    },

    updateApplicationValue(state, action) {
      state.filterValues.applicationNum = action.payload;
      state.valueIsValid.applicationNumIsValid =
        action.payload !== "" && action.payload !== null;
    },

    updateDropDownValue(state, action) {
      state.filterValues.dropDownValue = action.payload;
      state.valueIsValid.dropDownValueIsValid =
        action.payload !== "" && action.payload !== null;
    },

    updateInstruction(state, action) {
      state.filterValues.instruction = action.payload;
      state.valueIsValid.instructionIsValid =
        action.payload !== "" && action.payload !== null;
    },

    updateReason(state, action) {
      state.filterValues.reason = action.payload;
      state.valueIsValid.reasonIsValid =
        action.payload !== "" && action.payload !== null;
    },

    clearCustomerId(state, action) {
      state.filterValues.customerId = "";
    },

    resetExpectedDate(state, action) {
      state.filterValues.expectedDate = currentDate;
    },

    updateExpectedDate(state, action) {
      state.filterValues.expectedDate = action.payload;
      state.valueIsValid.expectedDateIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined &&
        action.payload >= currentDate &&
        action.payload <= state.filterValues.expectedEndDate;
    },

    //Reducer for touch handler
    updateBranchIsTouched(state, action) {
      state.touchHandler.branchTouched = action.payload;
    },
    updateApplicationNumberIsTouched(state, action) {
      state.touchHandler.applicationNumTouched = action.payload;
    },
    updateExpectedDateIsTouched(state, action) {
      state.touchHandler.expectedDateTouched = action.payload;
    },
    updateDropDownValueIsTouched(state, action) {
      state.touchHandler.dropDownValueTouched = action.payload;
    },

    updateInstructionIsTouched(state, action) {
      state.touchHandler.instructionIsTouched = action.payload;
    },

    updateReasonIsTouched(state, action) {
      state.touchHandler.reasonIsTouched = action.payload;
    },

    resetFilterValues(state, action) {
      state.filterValues.branch = null;
      state.filterValues.applicationArray = [];
      state.filterValues.applicationNum = null;
      state.filterValues.customerId = "";
      state.filterValues.expectedDate = currentDate;
      state.filterValues.dropDownValue = "";
      state.filterValues.expectedEndDate = endDate;
      state.filterValues.reason = "";
      state.filterValues.instruction = "";
    },

    updateFilterValues(state, action) {
      state.filterValues.branch = action.payload.branch;
      state.filterValues.applicationNum = action.payload.applicationNum;
      state.filterValues.customerId = action.payload.customerId;
      state.filterValues.expectedEndDate = action.payload.expectedEndDate;
    },

    resetAllTouchHandlers(state, action) {
      state.touchHandler = initialState.touchHandler;
      // since all gets reset so reset the valueIsValid also.
      state.valueIsValid = initialState.valueIsValid;
    },

    resetReasonValues(state, action) {
      state.filterValues.reason = "";
      state.filterValues.instruction = "";
      state.valueIsValid.reasonIsValid = false;
      state.valueIsValid.instructionIsValid = false;
      state.touchHandler.reasonIsTouched = false;
      state.touchHandler.instructionIsTouched = false;
    },
  },
});

export const SettlementFigureReportReducerAction =
  SettlementFigureReportReducer.actions;
export default SettlementFigureReportReducer.reducer;
